import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/Layout";
import Home from "@/pages/Home";
import { About, ServicesList, SectorsList, InfoPage } from "@/pages/Pages";
import ServiceDetail from "@/pages/ServiceDetail";
import { Blog, BlogPost, Faq } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import Careers from "@/pages/Careers";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/admin/AdminLayout";
import { Login, Setup } from "@/admin/AuthPages";
import Dashboard from "@/admin/Dashboard";
import Submissions from "@/admin/Submissions";
import ContentManager from "@/admin/ContentManager";
import PagesManager from "@/admin/PagesManager";
import SettingsPage from "@/admin/SettingsPage";
import { MediaPage, Account } from "@/admin/MediaAccount";
import Applications from "@/admin/hr/Applications";
import Callbacks from "@/admin/hr/Callbacks";
import Documents from "@/admin/hr/Documents";
import Reports from "@/admin/hr/Reports";
import Exports from "@/admin/hr/Exports";
import Notifications from "@/admin/hr/Notifications";
import Jobs from "@/admin/hr/Jobs";
import OpsApp from "@/ops/OpsApp";
import Aydinfest from "@/pages/Aydinfest";
import AydinfestAdmin from "@/admin/hr/Aydinfest";

function LegacyAdminRedirect() {
  const loc = useLocation();
  return <Navigate to={loc.pathname.replace(/^\/yonetim/, "/admin") + loc.search} replace />;
}

const LEGAL = ["kvkk-aydinlatma-metni", "gizlilik-politikasi", "cerez-politikasi", "kullanim-kosullari", "is-basvurusu-aydinlatma-metni", "teklif-formu-aydinlatma-metni"];

function AdminRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="giris" element={<Login />} />
        <Route path="kurulum" element={<Setup />} />
        <Route element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="teklifler" element={<Submissions kind="quotes" />} />
          <Route path="basvurular" element={<Applications />} />
          <Route path="gorevler" element={<Jobs />} />
          <Route path="geri-arama" element={<Callbacks />} />
          <Route path="aydinfest" element={<AydinfestAdmin />} />
          <Route path="belgeler" element={<Documents />} />
          <Route path="raporlar" element={<Reports />} />
          <Route path="disa-aktarma" element={<Exports />} />
          <Route path="bildirimler" element={<Notifications />} />
          <Route path="mesajlar" element={<Submissions kind="messages" />} />
          <Route path="hizmetler" element={<ContentManager ctype="services" />} />
          <Route path="sektorler" element={<ContentManager ctype="sectors" />} />
          <Route path="blog" element={<ContentManager ctype="posts" />} />
          <Route path="sss" element={<ContentManager ctype="faqs" />} />
          <Route path="sayfalar" element={<PagesManager />} />
          <Route path="medya" element={<MediaPage />} />
          <Route path="ayarlar" element={<SettingsPage />} />
          <Route path="hesap" element={<Account />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/operasyon/*" element={<OpsApp />} />
          <Route path="/yonetim/*" element={<LegacyAdminRedirect />} />
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/hizmetlerimiz" element={<ServicesList />} />
            <Route path="/hizmetler/:slug" element={<ServiceDetail />} />
            <Route path="/sektorler" element={<SectorsList />} />
            <Route path="/kalite-ve-guvenlik" element={<InfoPage pageKey="kalite-ve-guvenlik" image="/img/checkpoint.webp" />} />
            <Route path="/kariyer" element={<Careers />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/sikca-sorulan-sorular" element={<Faq />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/teklif-al" element={<Quote />} />
            <Route path="/aydinfest-basvuru" element={<Aydinfest />} />
            {LEGAL.map((k) => <Route key={k} path={`/${k}`} element={<InfoPage key={k} pageKey={k} />} />)}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </SiteProvider>
  );
}
